module.exports = __webpack_public_path__ + "static/downfor768-3d8364192bad1ea6669ee359845b57e7.png";